import Vue from 'vue';
import Search from "Components/Search/Search";

declare global {
	interface Window {
		dataLayer:any;
	}
}

/* Search-related functions */
export function init(): void {
	let searchResultsComp = document.getElementById("searchResultsComponent");
	function initializeSearchComponent() {
		if(searchResultsComp) {
			new Vue({
				render: h => h(Search)
			}).$mount('#searchResultsComponent');
		}
	}

	initializeSearchComponent();
}
